<div class="dropdown">
    <div class="select-btn" (click)="toggleDropdown()" #dropDownTrigger>
        <ng-container *ngIf="selectedValue; else placeholderTemplate">
            <ng-container *ngFor="let opt of options">
                <ng-container *ngIf="opt.value === selectedValue">
                    <div class="icon" *ngIf="opt.iconUrl" [ngStyle]="{ 'background-image': 'url(' + opt.iconUrl + ')' }"></div> <span>{{ opt.label }}</span>
                </ng-container>
            </ng-container>
        </ng-container>
        <ng-template #placeholderTemplate>
            {{ placeholder }}
        </ng-template>
        <i class="fa fa-caret-down"></i>
    </div>

    <ul class="select-options" [style.display]="dropdownOpen ? 'block' : 'none'" #dropDownList>
        <li *ngFor="let opt of options" (click)="selectOption(opt)">
            <div class="icon" *ngIf="opt.iconUrl" [ngStyle]="{ 'background-image': 'url(' + opt.iconUrl + ')' }"></div> <span>{{ opt.label }}</span>
        </li>
    </ul>
</div>
